'use client';

import { CUSTOM_EVENTS } from '@/constants';
import { createContext, useContext, useMemo, useRef, useState } from 'react';

const DictionaryContext = createContext({});

export const useGlossaryDictionary = () => useContext(DictionaryContext);

const getErrorMessage = (name, list = []) => {
  for (const item of list) if (item.label === name) return item.value;
  return '';
};

export default function DictionaryProvider({ children, errorMessages = [], entries = [] }) {
  const [search, setSearch] = useState('');

  const inputRef = useRef(null);

  const [errorMessage, setErrorMessage] = useState('');

  const handleSearch = () => {
    const value = inputRef.current.value;

    if (value.length && value.length < 3) {
      setErrorMessage(getErrorMessage('search_min_length', errorMessages));
      inputRef.current.focus();
      return;
    }

    // clear errors
    setErrorMessage('');

    setSearch(value);
  };

  const filteredGroups = useMemo(
    function () {
      return entries
        .map(entry => {
          const [letter, list = []] = entry;
          const filteredList = list.filter(item => item.title.toLowerCase().includes(search.toLowerCase()));
          return [letter, filteredList];
        })
        .filter(([, list]) => {
          return list.length > 0;
        });
    },
    [entries, search]
  );

  return (
    <DictionaryContext.Provider value={{ search, inputRef, errorMessage, handleSearch, filteredGroups }}>
      {children}
    </DictionaryContext.Provider>
  );
}
